import { z } from 'zod'

export const COACHING_SHELL_TOOL_VIEW_CONTRACT_VERSION = '1.0.0' as const
export const coachingShellToolViewResponseSchema = z.unknown()
export type CoachingShellToolViewResponse = z.infer<typeof coachingShellToolViewResponseSchema>
